const INITIAL_FRAME_MS = 0;
const EARLY_RETRY_MS = 60;
const MID_RETRY_MS = 160;
const LATE_RETRY_MS = 320;

/**
 * Delays (ms — 0 = next tick) at which scroll is re-applied after a pane is reactivated, to catch a
 * scroller whose content height settles asynchronously (data fetch, virtualization, or the page
 * rebuilding its scroller node on re-render).
 */
export const SCROLL_RESTORE_DELAYS = [
  INITIAL_FRAME_MS,
  EARLY_RETRY_MS,
  MID_RETRY_MS,
  LATE_RETRY_MS,
];
